import { i as d, x as a } from "./lit-element-6iugfgmM.js";
import { S as u } from "./Base-ChuuONkW.js";
import { n as l } from "./property-BWlAHqg_.js";
import { d as m } from "./define-element-Dl91r6Vu.js";
const f = d`
    :host{inline-size:100%;block-size:100%;justify-content:center;align-items:center;display:flex}::slotted(*){max-inline-size:100%;max-block-size:100%;object-fit:contain;transition:opacity var(--spectrum-asset-transition-duration)}.file,.folder{inline-size:max(48px,min(100%,80px));inline-size:max(var(--mod-asset-icon-min-width,48px),min(100%,var(--mod-asset-icon-max-width,80px)));block-size:100%;margin:20px;margin:var(--mod-asset-icon-margin,20px)}.folderBackground{fill:var(--highcontrast-asset-folder-background-color,var(--mod-asset-folder-background-color,var(--spectrum-asset-folder-background-color)))}.fileBackground{fill:var(--highcontrast-asset-file-background-color,var(--mod-asset-file-background-color,var(--spectrum-asset-file-background-color)))}.fileOutline,.folderOutline{fill:var(--mod-asset-icon-outline-color,var(--spectrum-asset-icon-outline-color))}@media (forced-colors:active){:host{--highcontrast-asset-folder-background-color:currentColor;--highcontrast-asset-file-background-color:currentColor}}:host{--spectrum-asset-transition-duration:var(--system-asset-transition-duration);--spectrum-asset-folder-background-color:var(--system-asset-folder-background-color);--spectrum-asset-file-background-color:var(--system-asset-file-background-color);--spectrum-asset-icon-outline-color:var(--system-asset-icon-outline-color)}
`;
var p = Object.defineProperty, n = (t, r, e, g) => {
  for (var i, o = void 0, s = t.length - 1; s >= 0; s--) (i = t[s]) && (o = i(r, e, o) || o);
  return o && p(r, e, o), o;
};
class c extends u {
  constructor() {
    super(...arguments), this.label = "";
  }
  static get styles() {
    return [f];
  }
  render() {
    return this.variant === "file" ? (r = this.label, a`
    <svg
        class="file"
        role="img"
        viewBox="0 0 128 128"
        aria-label=${r || "File"}
    >
        <path
            class="fileBackground"
            d="M24,126c-5.5,0-10-4.5-10-10V12c0-5.5,4.5-10,10-10h61.5c2.1,0,4.1,0.8,5.6,2.3l20.5,20.4c1.5,1.5,2.4,3.5,2.4,5.7V116c0,5.5-4.5,10-10,10H24z"
        ></path>
        <path
            class="fileOutline"
            d="M113.1,23.3L92.6,2.9C90.7,1,88.2,0,85.5,0H24c-6.6,0-12,5.4-12,12v104c0,6.6,5.4,12,12,12h80c6.6,0,12-5.4,12-12V30.4C116,27.8,114.9,25.2,113.1,23.3z M90,6l20.1,20H92c-1.1,0-2-0.9-2-2V6z M112,116c0,4.4-3.6,8-8,8H24c-4.4,0-8-3.6-8-8V12c0-4.4,3.6-8,8-8h61.5c0.2,0,0.3,0,0.5,0v20c0,3.3,2.7,6,6,6h20c0,0.1,0,0.3,0,0.4V116z"
        ></path>
    </svg>
`) : this.variant === "folder" ? ((e) => a`
    <svg
        class="folder"
        role="img"
        viewBox="0 0 32 32"
        aria-label=${e || "Folder"}
    >
        <path
            class="folderBackground"
            d="M3,29.5c-1.4,0-2.5-1.1-2.5-2.5V5c0-1.4,1.1-2.5,2.5-2.5h10.1c0.5,0,1,0.2,1.4,0.6l3.1,3.1c0.2,0.2,0.4,0.3,0.7,0.3H29c1.4,0,2.5,1.1,2.5,2.5v18c0,1.4-1.1,2.5-2.5,2.5H3z"
        ></path>
        <path
            class="folderOutline"
            d="M29,6H18.3c-0.1,0-0.2,0-0.4-0.2l-3.1-3.1C14.4,2.3,13.8,2,13.1,2H3C1.3,2,0,3.3,0,5v22c0,1.6,1.3,3,3,3h26c1.7,0,3-1.4,3-3V9C32,7.3,30.7,6,29,6z M31,27c0,1.1-0.9,2-2,2H3c-1.1,0-2-0.9-2-2V7h28c1.1,0,2,0.9,2,2V27z"
        ></path>
    </svg>
`)(this.label) : a`
            <slot></slot>
        `;
    var r;
  }
}
n([l({ type: String, reflect: !0 })], c.prototype, "variant"), n([l()], c.prototype, "label"), m("sp-asset", c);
//# sourceMappingURL=sp-asset-BCGiJwkS.js.map
